var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-observer", {
        ref: "observer",
        attrs: { tag: "form" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.validateBeforeSubmit($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c("div", { staticClass: "g-row g-row--space_lg" }, [
                  _c(
                    "div",
                    { staticClass: "g-cell g-cols g-cols--12 g-cols--6-md" },
                    [
                      _c("validation-provider", {
                        staticClass: "position_relative",
                        attrs: {
                          tag: "div",
                          rules: "alpha_spaces",
                          name: "name"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formdata.name,
                                        expression: "formdata.name"
                                      }
                                    ],
                                    staticClass:
                                      "form form--input margin_bottom_lg",
                                    attrs: {
                                      placeholder: "First Name",
                                      type: "text",
                                      name: "name",
                                      required: "required"
                                    },
                                    domProps: { value: _vm.formdata.name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formdata,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-text error-text--contact"
                                    },
                                    [_vm._v(_vm._s(errors[0]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _c("validation-provider", {
                        staticClass: "position_relative",
                        attrs: {
                          tag: "div",
                          rules: "alpha_spaces",
                          name: "lastname"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formdata.lastname,
                                        expression: "formdata.lastname"
                                      }
                                    ],
                                    staticClass:
                                      "form form--input margin_bottom_lg",
                                    attrs: {
                                      placeholder: "Last Name",
                                      type: "text",
                                      required: "required",
                                      name: "lastname"
                                    },
                                    domProps: { value: _vm.formdata.lastname },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formdata,
                                          "lastname",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-text error-text--contact"
                                    },
                                    [_vm._v(_vm._s(errors[0]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _c("validation-provider", {
                        staticClass: "position_relative",
                        attrs: { tag: "div", rules: "email", name: "email" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formdata.email,
                                        expression: "formdata.email"
                                      }
                                    ],
                                    staticClass:
                                      "form form--input margin_bottom_lg",
                                    attrs: {
                                      placeholder: "Email Address",
                                      type: "text",
                                      required: "required",
                                      name: "email"
                                    },
                                    domProps: { value: _vm.formdata.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formdata,
                                          "email",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-text error-text--contact"
                                    },
                                    [_vm._v(_vm._s(errors[0]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "g-cell g-cols g-cols--12 g-cols--6-md" },
                    [
                      _c("validation-provider", {
                        staticClass: "position_relative",
                        attrs: {
                          tag: "span",
                          rules: "alpha_spaces",
                          name: "message"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formdata.message,
                                        expression: "formdata.message"
                                      }
                                    ],
                                    staticClass:
                                      "form form--textarea margin_bottom_lg",
                                    attrs: {
                                      placeholder:
                                        "Describe your project in a few sentences",
                                      type: "text",
                                      name: "message",
                                      required: "required"
                                    },
                                    domProps: { value: _vm.formdata.message },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formdata,
                                          "message",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-text error-text--textarea"
                                    },
                                    [_vm._v(_vm._s(errors[0]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "g-row g-row--space_lg" }, [
                  _c(
                    "div",
                    { staticClass: "g-cell g-cols g-cols--12 g-cols--6-md" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "g-row g-row--align_center position_relative"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "g-cell g-cols g-cols--auto" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text_right color_darkgray fs_2sm"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.firstNumber) +
                                      " + " +
                                      _vm._s(_vm.secondNumber) +
                                      " = "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "g-cell g-cols g-cols--narrow" },
                            [
                              _c("validation-provider", {
                                staticClass: "position_relative",
                                attrs: {
                                  tag: "span",
                                  rules: { required: { allowFalse: false } },
                                  name: "formCaptcha"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.formCaptcha,
                                                expression: "formCaptcha"
                                              }
                                            ],
                                            staticClass: "form form--captcha",
                                            attrs: {
                                              type: "text",
                                              name: "formCaptcha"
                                            },
                                            domProps: {
                                              value: _vm.formCaptcha
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.formCaptcha =
                                                    $event.target.value
                                                },
                                                _vm.checkValue
                                              ]
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "error-text error-text--captcha"
                                            },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                          _vm.errorText.length !== 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "error-text error-text--captcha"
                                                },
                                                [_vm._v(_vm._s(_vm.errorText))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "g-cell g-cols g-cols--12 g-cols--6-md margin_top_sm-till-md"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button button--color_green button--width_full padding_full_md text_uppercase font-weight_bold display display--block cursor-pointer",
                          attrs: { disabled: _vm.clicked, type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.validateBeforeSubmit($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonName))]
                      )
                    ]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1202551a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1202551a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/UiForm/UiForm.vue
// module id = 65
// module chunks = 0